import axios, { AxiosRequestConfig, AxiosError } from 'axios';
// import SessionManager from '../../modules/identity/managers/SessionManager';

/**
 * Response error interceptor — извлекает серверный error.message из тела ответа.
 *
 * Без этого axios при HTTP-ошибках (403, 500 и т.д.) кидает AxiosError с дженерик
 * message "Request failed with status code 403", теряя человекочитаемое сообщение
 * от сервера (например, "Недостаточно прав для изменения лида").
 *
 * Формат серверного ответа: { error: { message: string, code?: string } }
 */
axios.interceptors.response.use(
  (response) => response,
  (error: AxiosError<{ error?: { message?: string; code?: string } }>) => {
    const serverMessage = error.response?.data?.error?.message;
    if (serverMessage) {
      // Заменяем message на серверный, сохраняя остальные свойства AxiosError
      error.message = serverMessage;
    }
    return Promise.reject(error);
  },
);

// Resolve API base URL (prod → '', dev → env or host/port)
const apiBaseUrl = (() => {
  const strip = (s: string) => (s === '' ? '' : s.replace(/\/$/, ''));

  // Browser (Vite)
  if (typeof import.meta !== 'undefined' && (import.meta as any).env) {
    const env: any = (import.meta as any).env;
    if (env.MODE === 'production') return '';
    if (env.VITE_API_BASE_URL !== undefined) return strip(String(env.VITE_API_BASE_URL));
    const host = env.VITE_SERVER_HOST ?? 'localhost';
    const port = env.VITE_SERVER_PORT ?? '5000';
    return `http://${host}:${port}`;
  }

  // Node (fallback)
  if (typeof process !== 'undefined' && process.env) {
    if (process.env.NODE_ENV === 'production') return '';
    if (process.env.VITE_API_BASE_URL !== undefined) return strip(String(process.env.VITE_API_BASE_URL));
    const host = process.env.SERVER_HOST ?? 'localhost';
    const port = process.env.SERVER_PORT ?? '5000';
    return `http://${host}:${port}`;
  }

  return 'http://localhost:5000';
})();

function _get(url: string, config: AxiosRequestConfig = {}) {
  // const sessionManager = SessionManager.getInstance<SessionManager>();
  const _config = {
    ...config,
    headers: {
      // Authorization: `Bearer ${sessionManager.getAccessToken()}`,
      ...config.headers,
    },
  };
  return axios.get(`${apiBaseUrl}${url}`, _config);
}

function _post(url: string, data: any = {}, config: AxiosRequestConfig = {}) {
  // const sessionManager = SessionManager.getInstance<SessionManager>();
  const _config = {
    ...config,
    withCredentials: true,
    withXSRFToken: true,
    headers: {
      // Authorization: `Bearer ${sessionManager.getAccessToken()}`,
      ...config.headers,
    },
  };
  return axios.post(`${apiBaseUrl}${url}`, data, _config);
}

function _put(url: string, data: any = {}, config: AxiosRequestConfig = {}) {
  // const sessionManager = SessionManager.getInstance<SessionManager>();
  const _config = {
    ...config,
    headers: {
      // Authorization: `Bearer ${sessionManager.getAccessToken()}`,
      ...config.headers,
    },
  };
  return axios.put(`${apiBaseUrl}${url}`, data, _config);
}

function _delete(url: string, config: AxiosRequestConfig = {}) {
  // const sessionManager = SessionManager.getInstance<SessionManager>();
  const _config = {
    ...config,
    headers: {
      // Authorization: `Bearer ${sessionManager.getAccessToken()}`,
      ...config.headers,
    },
  };
  return axios.delete(`${apiBaseUrl}${url}`, _config);
}

export { apiBaseUrl };

export const fetcher = {
  get: _get, post: _post, put: _put, delete: _delete,
};
